export default __webpack_public_path__ + "static/media/belt_of_fiendish_invocation.217d025c.jpg";